import React from "react";
import { Paper, Typography, Button, TextField, Box, Divider } from '@mui/material';

function ResumePersonalization({ resumeText, resumeFile, onResumeTextChange, onResumeFileChange, error }) {
  return (
    <Paper elevation={3} sx={{ p: 4, mt: 4, borderRadius: 3, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h5" fontWeight={700} gutterBottom align="center">
        Personalize Your Course Recommendations
      </Typography>
      <TextField
        label="Paste or type your resume"
        value={resumeText}
        onChange={onResumeTextChange}
        multiline
        rows={5}
        fullWidth
        margin="normal"
        disabled={!!resumeFile}
        placeholder="Paste or type your resume here..."
      />
      <Divider sx={{ my: 2 }}>OR</Divider>
      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <Button
          variant="contained"
          component="label"
          sx={{ fontWeight: 600, textTransform: 'none' }}
          disabled={!!resumeText}
        >
          {resumeFile ? resumeFile.name : "Upload Resume"}
          <input
            type="file"
            accept=".pdf,.doc,.docx,.txt"
            hidden
            onChange={onResumeFileChange}
          />
        </Button>
        {resumeFile && (
          <Button color="secondary" onClick={() => onResumeFileChange({ target: { files: [] } })} size="small">
            Remove
          </Button>
        )}
      </Box>
      {error && <Typography color="error" sx={{ mt: 2 }}>{error}</Typography>}
    </Paper>
  );
}

export default ResumePersonalization; 